<!--Render-->
@if (!(action?.editable && action?.target[id] == targetId)) {
  <div class="label">
    {{ value }}
  </div>
}
<!--Edit-->
@if (action?.editable && action?.target[id] == targetId) {
  <div class="flex-it flex-row flex-nowrap flex-xcontent-center flex-item-auto">
    <!--Input-->
    <mat-form-field>
      <input
        matInput
        [value]="value"
        class="input-control"
        (input)="setData($event.target.value)"
      />
    </mat-form-field>
  </div>
}
